import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import DeleteItemModalWrapper from '../../components/Modals/DeleteItemModalWrapper'
import DeleteItemModal from '../../components/Modals/DeleteItemModal'
import useDeleteAction from './index'

import {
  lineItemDeleteErrorSelector,
  lineItemDeleteIsLoadingSelector,
  lineItemDeleteSelector,
  lineItemSelector,
  lineItemWasLoadedSelector
} from '../../../modules/selectors/lineItems'
import { clearDeleteLineItem, clearLineItem, deleteLineItem, getLineItem } from '../../../modules/actions/lineItems'

export const useDeleteLineItemAction = ({ updateAds = false, updateCombinedLineItems = false } = {}) => {
  const dispatch = useDispatch()

  const item = useSelector(lineItemSelector)
  const lineItemWasLoaded = useSelector(lineItemWasLoadedSelector)

  const deleteLineItemHandler = useCallback(
    params => {
      dispatch(
        deleteLineItem(params, {
          updateAds,
          updateCombinedLineItems
        })
      )
    },
    [dispatch, updateAds, updateCombinedLineItems]
  )

  const clearDeleteLineItemHandler = useCallback(() => {
    dispatch(clearDeleteLineItem())
  }, [dispatch])

  const {
    handleDelete,
    handleDeleteRequest,
    handleCloseDeleteModal,
    isDeleteModalOpened,
    deleteItemIsLoading,
    dataWaitingForDelete
  } = useDeleteAction({
    onDelete: deleteLineItemHandler,
    onClearDelete: clearDeleteLineItemHandler,
    deletedItemSelector: lineItemDeleteSelector,
    deleteItemIsLoadingSelector: lineItemDeleteIsLoadingSelector,
    deleteItemErrorSelector: lineItemDeleteErrorSelector
  })

  const getListItemHandler = useCallback(() => {
    const {
      item = {},
      platform: selectedPlatform = '',
      account: selectedAdAccountId = '',
      campaignObjective
    } = dataWaitingForDelete

    const { id: lineItemId } = item

    dispatch(
      getLineItem(
        {
          return_impressions: true, // todo PBR-1221 check if this param works when BE done
          id: lineItemId,
          account: selectedAdAccountId,
          campaign_objective: campaignObjective
        },
        selectedPlatform
      )
    )
  }, [dispatch, dataWaitingForDelete])

  const clearHandler = useCallback(() => {
    dispatch(clearLineItem())
  }, [dispatch])

  return useMemo(() => {
    return {
      handleDeleteRequest,
      DeleteLineItemModal: (
        <DeleteItemModalWrapper
          isDeleteModalOpened={isDeleteModalOpened}
          handleCloseDeleteModal={handleCloseDeleteModal}
          dataWaitingForDelete={dataWaitingForDelete}
          getListItemHandler={getListItemHandler}
          clearHandler={clearHandler}
          loadedItem={item}
          itemWasLoaded={lineItemWasLoaded}
        >
          <DeleteItemModal
            handleDelete={handleDelete}
            handleCloseDeleteModal={handleCloseDeleteModal}
            isDeleteModalOpened={isDeleteModalOpened}
            deleteItemIsLoading={deleteItemIsLoading}
            deleteModalMessage="This cannot be undone."
            // props for archive button
            // archiveProps={{
            //   updateItemAction: updateLineItem,
            //   updatedItemSelector: lineItemUpdateSelector,
            //   updateItemErrorSelector: lineItemUpdateErrorSelector,
            //   updateItemIsLoadingSelector: lineItemUpdateIsLoadingSelector,
            //   clearSubmitAction: clearUpdateLineItem,
            //   dataWaitingForDelete
            // }}
          />
        </DeleteItemModalWrapper>
      )
    }
  }, [
    handleDeleteRequest,
    isDeleteModalOpened,
    handleCloseDeleteModal,
    dataWaitingForDelete,
    handleDelete,
    deleteItemIsLoading,
    item,
    lineItemWasLoaded,
    getListItemHandler,
    clearHandler
  ])
}
